export const API_BASE = process.env.NEXT_PUBLIC_API_BASE;
export const API_URL = `${API_BASE}/api/`;
export const token = process.env.NEXT_PUBLIC_TOKEN_FORM_CONTACT;
export const HOTJAR_ID = process.env.NEXT_PUBLIC_HOTJAR_ID;
export const GA_ID = process.env.NEXT_PUBLIC_GA_ID;
export const PUBLICATION_STATE_PARAM =
  process.env.NEXT_PUBLIC_ENVIRONMENT === "preview"
    ? "&publicationState=preview"
    : "";
